// @ts-check
import ShrinkWrap from 'Components/Common/ShrinkWrap';
import Popup from "Components/Common/popup";
import Switcher from "Components/Common/switcher";
import 'Styles/commonComponents/settings/switcherSetting.scss';
import IconsContainer from "Utils/IconsContainer";
import { observer } from 'mobx-react';
import React from "react";

/**
 * @param {{
 * id?: string,
 * className?: string,
 * title: string,
 * helperText?: string,
 * disabled?: boolean,
 * value: boolean,
 * onChanged: (arg0: boolean) => void
 * }} props 
 * @returns {React.JSX.Element}
 */
const SwitcherSetting = (props) => {
    return (
        <div
            className={'setting-container switcher-setting ' + (props.className ? props.className : '')}>
            <div className='setting-title switcher-setting-title'>
                <ShrinkWrap>
                    {props.title}
                </ShrinkWrap>
                {props.helperText ?
                    <Popup
                        popupText={props.helperText}
                        className='fast-info-popup'>
                        {IconsContainer.Get('ci-info')}
                    </Popup>
                    : ''}
            </div>
            <Switcher
                id={props.id}
                className={(props.disabled === true ? " disabled" : "")}
                currentState={props.value}
                changed={(value) => props.onChanged(value)} />
        </div>
    )
}

export default observer(SwitcherSetting);